import Auth from './Auth';

export default function IsAuthenticated() {
    var auth = new Auth();
    return auth.loggedIn();
}